/** `sync:<projectId>[:<runId>]` page ids. The run id is optional for the plain project Sync page. */
export function parseSyncRoute(page: string): { projectId: string; runId?: string } | null {
  if (!page.startsWith('sync:')) return null;
  const [, projectId, runId] = page.split(':');
  if (!projectId) return null;
  return runId ? { projectId, runId } : { projectId };
}

export function syncRoute(projectId: string, runId?: string | null): string {
  return runId ? `sync:${projectId}:${runId}` : `sync:${projectId}`;
}

/** True when the page was opened for a specific run but is showing a different one (or none). Never true while
 * the project's history is still loading, and never when no run was requested. */
export function syncRunMismatch(input: { expectedRunId?: string; loading: boolean; activeRunId: string | null; latestRunId: string | null }): boolean {
  if (!input.expectedRunId || input.loading) return false;
  const shown = input.activeRunId ?? input.latestRunId;
  return shown !== input.expectedRunId;
}
